export function importAllImages(r) {
  return r.keys().map(r);
}

export function loadAllFolders() {
  const importAll = importAllImages;
  return {
    '1': importAll(require.context('../images/1', false, /\.(png|jpe?g)$/)),
    '2': importAll(require.context('../images/2', false, /\.(png|jpe?g)$/)),
    '3': importAll(require.context('../images/3', false, /\.(png|jpe?g)$/)),
    '4': importAll(require.context('../images/4', false, /\.(png|jpe?g)$/)),
    '5': importAll(require.context('../images/5', false, /\.(png|jpe?g)$/)),
    '6': importAll(require.context('../images/6', false, /\.(png|jpe?g)$/)),
    '7': importAll(require.context('../images/7', false, /\.(png|jpe?g)$/)),
    '8': importAll(require.context('../images/8', false, /\.(png|jpe?g)$/)),
    '9': importAll(require.context('../images/9', false, /\.(png|jpe?g)$/)),
    '10': importAll(require.context('../images/10', false, /\.(png|jpe?g)$/)),
    'lkg': importAll(require.context('../images/lkg', false, /\.(png|jpe?g)$/)),
    'ukg': importAll(require.context('../images/ukg', false, /\.(png|jpe?g)$/)),
    'inter': importAll(require.context('../images/inter', false, /\.(png|jpe?g)$/))
  };
}
